<template>
  <div class="absolute inset-0 pt-20vh overflow-auto normal-scroll scroll-end">
    <div class="text-center">
      <h1>{{ more.title }}</h1>

      <div class="lg:inline-flex">
        <div
          v-for="(cta, i) in more.ctas"
          :key="`cta-${i}`"
          class="cta-container flex-c h-56 w-68 md:h-48 md:w-96 lg:h-23vw lg:w-25vw xl:h-18vw xl:w-20vw mx-auto lg:mx-6 my-6 pb-12 lg:pb-12 bg-primary bg-cover bg-center"
          :style="`background-image: url(${publicPath}uploads/images/${cta.image.src})`"
        >
          <a
            :href="utmHref(cta.linkout, 'tier-1-cta')"
            target="_blank"
            class="flex-c self-end w-90% md:w-56 md:px-4 py-3 font-bold btn--primary focus-a"
            :class="{ 'hover:underline focus:underline': !touch }"
          >
            {{ cta.title }}
            <svg xmlns="http://www.w3.org/2000/svg" width="36" height="32" viewBox="0 0 36 32" v-bind:svg-inline="''" v-bind:class="'inline-block h-4 w-4 ml-1 fill-current'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M36 1.5v7.999a1.501 1.501 0 01-2.561 1.06l-2.232-2.232-15.221 15.22c-.271.271-.646.439-1.061.439s-.789-.168-1.061-.439l-1.414-1.414c-.271-.271-.439-.646-.439-1.061s.168-.789.439-1.061L27.671 4.792 25.44 2.56a1.5 1.5 0 011.059-2.561h8c.828 0 1.499.671 1.499 1.499v.001zM25.439 16.925l-1.003 1.003a1.5 1.5 0 00-.438 1.055v9.018H4V8h16.502c.413 0 .788-.167 1.059-.438l1.003-1.003a1.5 1.5 0 00-1.06-2.56H3a3 3 0 00-3 3V29a3 3 0 003 3h22.002a3 3 0 003-3V17.985v-.001a1.5 1.5 0 00-2.563-1.059z"/></svg>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'More',

  data: () => ({
    publicPath: process.env.BASE_URL
  }),

  computed: {
    ...mapState([ 'touch', 'mobile' ]),
    ...mapGetters([ 'more' ])
  }
}
</script>

<style scoped>
.cta-container {
  clip-path: polygon(0 0, 100% 0, 100% 77%, 81% 100%, 0 100%);
}

@screen md {
  .cta-container {
    clip-path: polygon(0 0, 100% 0, 100% 60%, 80% 100%, 0 100%);
  }
}

@screen lg {
  .cta-container {
    clip-path: polygon(0 0, 100% 0, 100% 78%, 80% 100%, 0 100%);
  }
}
</style>
